import React from 'react';

const SepoliaIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <g clip-path="url(#OOE__a)">
            <path fill="#000" d="M24 0H0v24h24z" />
            <path fill="#fff" fill-rule="evenodd" d="M18.204 12.497q.025-.358.014-.716c.578-.036 1.284-.222 1.67-.347A.16.16 0 0 0 20 11.28V9.932a.18.18 0 0 0-.144-.167.2.2 0 0 0-.078.003 9 9 0 0 1-1.818.302h-.005a7.111 7.111 0 1 0-.088 4.151l.093.009c.613.022 1.48-.204 1.929-.356a.16.16 0 0 0 .111-.15v-1.347a.18.18 0 0 0-.222-.165 8.5 8.5 0 0 1-1.574.28zm-1.768-.16a5.4 5.4 0 0 0-.014-.823l-.253-.053c-.907-.2-1.867-.409-2.307-.373-.418.035-1.182.222-1.653.346a.165.165 0 0 1-.21-.16V9.812c0-.071.045-.133.107-.151.374-.129 1.112-.32 1.756-.32.391 0 .969.151 1.609.311l.489.129a5.333 5.333 0 1 0 .142 4.111c-.889-.195-1.809-.395-2.24-.355-.418.03-1.182.217-1.653.342a.165.165 0 0 1-.21-.16v-1.462c0-.072.045-.134.107-.152.374-.128 1.112-.32 1.756-.32.391 0 .969.152 1.609.312.311.088.64.168.965.24" clip-rule="evenodd" />
        </g>
        <defs>
            <clipPath id="OOE__a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>

);

export default SepoliaIcon;
